import React from 'react'

import tileimage6 from '../assets/images/whoweare/Corprate_WhoWeAre_SLT_06.jpg'
import tileimage145 from '../assets/images/whoweare/jared_bw_web.jpg'
import tileimage145678 from '../assets/images/whoweare/LAURA_2_BW_web.jpg'
import tileimage1456789 from '../assets/images/whoweare/Corprate_WhoWeAre_SLT_07.jpg'
import tileimage61 from '../assets/images/whoweare/John_Szczepanski.jpg'
import tileimage1451 from '../assets/images/whoweare/PHIL_ENDE_BW_web.jpg'
import tileimage1453 from '../assets/images/whoweare/Smeeta_Khetarpaul_BW.jpg'
import tileimage1452 from '../assets/images/whoweare/Kristin_Clifford_Digital_BW.jpg'
import tileimage14534 from '../assets/images/whoweare/rajendra.jpg'
import tileimage145345 from '../assets/images/whoweare/tiffany.jpg'

const MBSeniorLeadership = () => (
  <div
    class="secondgroup text-left accordion"
    id="mbseniorleadershipcolapsegroup"
  >
    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample1199"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample1199"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage1456789} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>CLAUDIA LIMA-GUINEHUT</h5>
          <p>Brand President</p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample1199"
        data-toggle="collapse"
        data-target="#collapseExample1199"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
            Claudia rejoined The Children’s Place in 2024 as Brand President. In
            her prior tenure at The Children’s Place from 2014 to 2023, Claudia
            served in roles of increasing responsibility, most recently as
            Senior Vice President, Global Merchandising and Strategic
            Partnerships, a role in which she was responsible for creating and
            delivering product strategies for all brands across multiple
            channels of distribution, as well as leading operations for
            wholesale and international franchise businesses. Claudia most
            recently served as Executive Vice President and Chief Merchandising
            Officer of Claire's Holdings LLC. Prior to that, she was Director of
            International Merchandising for Destination Maternity from 2011
            until 2014 and held roles across merchandising and product design
            functions at Zara, Camuto Group, Ralph Lauren and Fifth &amp;
            Pacific Companies. She earned her Bachelor of Science in Marketing
            from New York University and her SIPA Master of Business
            Administration from Columbia University.
          </p>
        </div>
      </div>
    </div>

    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample777"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample777"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage61} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>JOHN SZCZEPANSKI</h5>
          <p>Chief Financial Officer</p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample777"
        data-toggle="collapse"
        data-target="#collapseExample777"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          John joined The Children’s Place in 2025 as the Chief Financial Officer. In this role, he oversees all Finance functions, including Accounting, Financial Planning & Analysis, Tax, Treasury and Internal Audit, with additional oversight responsibilities of Real Estate and Investor Relations. John brings extensive financial experience from both the retail and manufacturing sectors, along with a proven track record of developing strong and efficient business models that align with the company’s financial strategy and support long-term success. Before joining The Children’s Place, John served as CFO at Vince Holding Corp. He also had a lengthy tenure at Ralph Lauren Corporation, where he advanced through various roles of increasing responsibility, culminating in his appointment as CFO for Global Supply Chain, Brands, and the Lifestyle Group. John holds a Master of Science in Finance from Boston College’s Carroll School of Management and a Bachelor of Science in Accounting from Fordham University.
          </p>
        </div>
      </div>
    </div>

    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample77"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample77"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage145} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>JARED SHURE</h5>
          <p>Chief Administrative Officer, General Counsel &amp; Secretary</p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample77"
        data-toggle="collapse"
        data-target="#collapseExample77"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
            Jared Shure joined The Children's Place in 2018 as Vice President,
            Assistant General Counsel and has assumed roles of increasing
            responsibility culminating in his appointment to the role of Senior
            Vice President, General Counsel in 2021 and Chief Administrative
            Officer in 2024. In his current role, Jared leads all areas of the
            Legal and Human Resources teams including Board Governance and
            Administration, and oversees Responsible Sourcing and Enterprise
            Risk. Jared attained his Bachelor of Science in Business
            Administration from the University of North Carolina at Chapel Hill
            and his Juris Doctorate from Cornell Law School.
          </p>
        </div>
      </div>
    </div>


    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample5"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample5"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage6} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>JENNIFER GROVES</h5>
          <p>
            Senior Vice President,
            <br /> Design &amp; Brand Creative
          </p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample5"
        data-toggle="collapse"
        data-target="#collapseExample3"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
            Jennifer Groves joined The Children's Place in 2014. She leads
            global product design for our brands. Her 25 years of creative
            design experience determines the brand’s seasonal color, concept,
            and overall aesthetic. Prior to joining The Children’s Place, she
            held Senior Vice President roles at Aeropostale and Gap Kids &amp;
            Baby. She also held design roles of increasing responsibility at
            Abercrombie &amp; Fitch, Guess and Bebe Stores. Jennifer earned a
            Bachelor of Fine Arts in Fashion Design from Parsons School of
            Design.
          </p>
        </div>
      </div>
    </div>
    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample778"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample778"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage1452} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>KRISTIN CLIFFORD</h5>
          <p>
          Senior Vice President, Head of Sourcing
          </p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample778"
        data-toggle="collapse"
        data-target="#collapseExample778"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Kristin rejoined The Children’s Place in 2025 as the Senior Vice President, Head of Global Sourcing. Kristin leads sourcing initiatives and manages teams of sourcing professionals in developing costing strategies to meet the company’s financial targets by collaborating with external partners to produce high-quality merchandise that is brand-consistent and competitively priced. Previously, Kristin worked at The Children’s Place from 2013 to 2020, where she held various roles of increasing responsibility, ultimately rising to the position of Vice President of Global Sourcing. Most recently, she served as the Senior Vice President of Sourcing at Vineyard Vines. Additionally, Kristin has held key leadership positions, including Senior Vice President of Global Sourcing at Juicy Couture and Vice President of Corporate Sourcing Operations at Liz Claiborne. She earned her Bachelor of Arts in Business Economics from Belmont Abbey College.
          </p>
        </div>
      </div>
    </div>
    

    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample779"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample779"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage1453} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>SMEETA KHETARPAUL</h5>
          <p>
          Senior Vice President, Head of Marketing
          </p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample779"
        data-toggle="collapse"
        data-target="#collapseExample779"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Smeeta joined The Children’s Place in 2025 as the Senior Vice President, Head of Marketing. Smeeta leads global brand and commercial marketing teams across all brands with the goal of elevating brand positioning, relevance, and driving growth across all channels. Smeeta brings over two decades of marketing experience with beauty, CPG, and retail brands, working at Fortune 500 companies. In her last role, she served as the VP Marketing for Crocs, Inc., where she led marketing for North America and Brazil. Prior to that, she worked at Avon cosmetics, Nestle, and Danone. She holds two Master's degrees, MA in Consumer Behavior from Michigan State University, and MBA from the Institute for Technology and Management, India. 
          </p>
        </div>
      </div>
    </div>
    

    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample7799"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample7799"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage14534} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>RAJENDRA KARAMCHETI</h5>
          <p>
          Senior Vice President, Chief Technology Officer
          </p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample7799"
        data-toggle="collapse"
        data-target="#collapseExample7799"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Rajendra joined The Children’s Place in 2019 and has taken on roles with increasing responsibility throughout his tenure with TCP. Currently serving as SVP, Chief Technology Officer, Rajendra leads the company’s global technology strategy, overseeing IT, digital infrastructure, and innovative initiatives. He is responsible for driving technology transformation efforts that enhance operational efficiency, promote business growth, and improve the customer experience. Rajendra has played a key role in modernizing the company’s technology platforms, optimizing operations, and aligning digital capabilities with strategic business objectives. He holds a Bachelor’s degree in Computer and Information Science from Andhra University.
          </p>
        </div>
      </div>
    </div>
    

    <div>
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample777"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample777"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage1451} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>PHILIP ENDE</h5>
          <p>GVP, Head of Real Estate</p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample777"
        data-toggle="collapse"
        data-target="#collapseExample777"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Philip joined The Children’s Place in 2024 as GVP, Head of Real Estate.  He oversees all real estate strategy and asset management, including acquisition, development, and leasing. Prior to joining, Philip served as President and Founder of Ende Real Estate Advisors, a real estate consulting firm.  Prior to that, he worked at Simon Property Group holding roles of increasing responsibility, culminating in his position as Senior Vice President – Leasing Premium Outlets.  Philip earned his Bachelor’s Degree from the University of Florida. 
          </p>
        </div>
      </div>
    </div>
    
    <div>
      
      <a
        class="row btn p-0 mb-1 d-flex collapsed"
        data-toggle="collapse"
        href="#collapseExample11901"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample11901"
      >
        <div class="col-12">
          <hr class="border-top " />
        </div>
        <div class="col-4 fill">
          <img src={tileimage145345} className="img-fluid mb-2" alt="" />
        </div>

        <div class="col-8 text-left">
          <h5>TIFFANY WHITFORD</h5>
          <p>
          GVP, Head of Stores
          </p>
        </div>
      </a>
      <div
        class="row mt-4 collapse close-button"
        id="collapseExample11901"
        data-toggle="collapse"
        data-target="#collapseExample11901"
        aria-expanded="false"
        aria-controls=""
        data-parent="#mbseniorleadershipcolapsegroup"
      >
        <div class="col-12">
          <p className="text-left">
          Tiffany joined The Children’s Place in 2025 as the GVP, Head of Stores, bringing with her a passion for creating exceptional customer experiences. In her role, she oversees store operations and field leadership, prioritizing impactful connections with customers. Prior to this, Tiffany served as Zone Vice President for Sunglass Hut Northeast at EssilorLuxottica and held influential positions at MAC Cosmetics North America and Kate Spade & Company. Tiffany's collaborative and results-driven leadership style is known for strengthening customer relationships and driving impressive growth. She holds a BFA and an AAS in Fashion Buying and Merchandising from the Fashion Institute of Technology.
          </p>
        </div>
      </div>
    </div>


  </div>
)

export default MBSeniorLeadership
